import { GenericService } from './generic.service';
import { BPMLocation } from '@/models';

export class OrganisationLocationService extends GenericService<BPMLocation> {

  constructor(organisationId: string) {
    super(`v1/organisations/${organisationId}/locations`);
  }
}
